import { RtoasterParameter } from "../rtoaster/rtoaster_utils";

export const setParametersCallBack = (rtoasterParameter?: RtoasterParameter) => {
  if (rtoasterParameter) {
    if (rtoasterParameter.catalogItemCode) Rtoaster.item(rtoasterParameter.catalogItemCode);
  }
}